'use strict';

import 'google';

import { resolveCurrentPosition } from 'incidents/components/buttons/log/add';
import { getUrlVars } from 'utils';

import sharedMapStyles from './sharedMapStyles';


export default function () {
  'ngInject';

  return {
    scope: {
      lat: '<',
      lng: '<',
      mapStyles: '<',
    },
    link: {
      pre: preLink,
    },
    controller: controller,
    controllerAs: '$checkinCtrl',
    transclude: true,
  }

  function preLink(scope, element, attrs, ctrl, transclude) {
    const urlParams = getUrlVars();
    if (scope.lat === undefined || scope.lng === undefined) {
      scope.lat = parseFloat(urlParams.lat || '39.1308');
      scope.lng = parseFloat(urlParams.lng || '-94.619');
    }
    transclude(scope, function (clone, scope) {
      element.append(clone);
      const mapElement = element[0].querySelector('#checkin-map');
      const map = new google.maps.Map(mapElement, {
        zoom: 10,
        center: { lat: scope.lat, lng: scope.lng },
        mapTypeId: 'roadmap',
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP,
        },
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: scope.mapStyles || sharedMapStyles,
        clickableIcons: false,
        keyboardShortcuts: false,
      });
      ctrl.setMap(map)
    });
  }

  function controller($q, $timeout) {
    'ngInject';

    // Initialize data
    const vm = this;

    vm.checkinKey = getUrlVars().ck;
    vm.note = '';

    vm.reset = () => {
      setPosition(null);
      vm.setPositionConfirmed(false);
      vm.note = '';
      vm.submitted = false;
      vm.getNavigatorPosition();
    }


    function setPosition(position) {
      vm.position = position;
    }

    vm.setPositionConfirmed = (value) => {
      vm.positionConfirmed = value;
      if (vm.map.getZoom() < 17) {
        vm.map.setZoom(17);
      }
      vm.map.setOptions({
        draggable: !value,
        keyboardShortcuts: value,
        disableDoubleClickZoom: !value,
        zoomControl: !value,
      })
    }

    function handleMoveStart(e) {
      $timeout(() => {
        vm.mapMoving = true;
      }, 0);
    }

    function handleMoveEnd() {
      $timeout(() => {
        vm.mapMoving = false;
      }, 0);
    }

    vm.setMap = (map) => {
      vm.map = map;
      vm.map.addListener('dragstart', handleMoveStart);
      vm.map.addListener('dragend', handleMoveEnd);
      vm.map.addListener('center_changed', (e) => {
        $timeout(() => {
          const center = vm.map.getCenter();
          setPosition({ lat: center.lat(), lng: center.lng() });
        }, 0);
      });
      vm.getNavigatorPosition();
    }

    vm.getNavigatorPosition = () => {
      var deferred = $q.defer();
      vm.positionLoading = true;
      deferred.promise.then((position) => {
        if (!vm.positionLoading) return;
        vm.map.panTo({ lat: position.coords.latitude, lng: position.coords.longitude });
        if (vm.map.getZoom() < 17) {
          $timeout(() => { vm.map.setZoom(17); }, 250);
        }
      }, (error) => {
        vm.permissionErrorCode = error.code;
      }).finally(() => {
        vm.positionLoading = false;
      });
      resolveCurrentPosition(deferred, 2, [], true);
    }

    vm.handleCheckinError = (error) => {
      console.error(error);
    }
  }
}
